import { render, staticRenderFns } from "./AudienceCampaignForm.vue?vue&type=template&id=3cbaf97a&scoped=true"
import script from "./AudienceCampaignForm.vue?vue&type=script&lang=js"
export * from "./AudienceCampaignForm.vue?vue&type=script&lang=js"
import style0 from "./AudienceCampaignForm.vue?vue&type=style&index=0&id=3cbaf97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbaf97a",
  null
  
)

export default component.exports